import React from "react";
import {
  DeleteOutlined,
  EditOutlined,
  InboxOutlined,
  MergeCellsOutlined,
  PlusCircleOutlined,
  SwapOutlined,
} from "@ant-design/icons";

/**
 * The kinds of change of the final check — ONE icon, ONE colour, ONE plain French word each,
 * used on every line, card, navigation dot and in the legend (colours live in split.scss,
 * class `sv-k-<kind>`). Order = legend order = priority when an entity carries several kinds.
 */
export const KINDS = {
  id_replaced: {
    word: "id remplacé",
    icon: SwapOutlined,
    color: "#1677ff",
    explain: "le lien pointe vers une autre fiche (l'identifiant change)",
  },
  modified: {
    word: "modifié",
    icon: EditOutlined,
    color: "#fa8c16",
    explain: "la valeur change",
  },
  merged: {
    word: "fusionné",
    icon: MergeCellsOutlined,
    color: "#722ed1",
    explain: "deux fiches deviennent une",
  },
  deleted: {
    word: "supprimé",
    icon: DeleteOutlined,
    color: "#cf1322",
    explain: "la fiche disparaît (elle est gardée dans le journal)",
  },
  created: {
    word: "créé",
    icon: PlusCircleOutlined,
    color: "#389e0d",
    explain: "une nouvelle fiche apparaît",
  },
  archived: {
    word: "archivé",
    icon: InboxOutlined,
    color: "#8c8c8c",
    explain: "la fiche reste mais n'est plus utilisée",
  },
};
export const KIND_ORDER = [
  "id_replaced",
  "modified",
  "merged",
  "deleted",
  "created",
  "archived",
];
/** When one entity carries several kinds, the most consequential one names the card. */
export const KIND_PRIORITY = [
  "deleted",
  "merged",
  "created",
  "archived",
  "modified",
  "id_replaced",
];

export const isKind = k => Object.prototype.hasOwnProperty.call(KINDS, k);

/** The icon of a kind alone (navigation dots, section badges). */
export function KindIcon({ kind, className = "" }) {
  const k = KINDS[kind];
  if (!k) return null;
  const Icon = k.icon;
  return <Icon className={`sv-k-${kind} sv-kind-icon ${className}`} />;
}

/** « ✏️ modifié » pill; `label` overrides the word (e.g. an action label). */
export function KindTag({ kind, label, size = "default" }) {
  const k = KINDS[kind];
  if (!k) return null;
  const Icon = k.icon;
  return (
    <span className={`sv-kind sv-kind--${size} sv-k-${kind}`}>
      <Icon className="sv-kind-glyph" />
      <span>{label || k.word}</span>
    </span>
  );
}

/** A coloured dot per kind (navigation). */
export function KindDot({ kind }) {
  const k = KINDS[kind];
  if (!k) return null;
  return <span className={`sv-dot sv-k-${kind}`} title={k.word} />;
}
